import { axiosPrivateInstance } from 'libs/axios';
import { GET_ALL_PRODUCT_TYPE } from 'utils/serviceUrls';

const getAllProductTypeService = async () => {
	// eslint-disable-next-line no-return-await
	return await axiosPrivateInstance
		.post(GET_ALL_PRODUCT_TYPE)
		.then((response: any) => {
			return response;
		})
		.catch(() => {
			return false;
		});
};

export default getAllProductTypeService;
